import { render, staticRenderFns } from "./DesktopPaymentMethod.vue?vue&type=template&id=eb0972fc&scoped=true"
import script from "./DesktopPaymentMethod.vue?vue&type=script&lang=js"
export * from "./DesktopPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./DesktopPaymentMethod.vue?vue&type=style&index=0&id=eb0972fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0972fc",
  null
  
)

export default component.exports